import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./image-cards.${locale}.json`));
